import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { ReactRenderer } from '@atlaskit/renderer';
import { N20, N40, N70 } from '@atlaskit/theme/colors';
import { DisplayMode } from '../../RenderForm';
import { ViewWrapper } from '../common/questionWrappers';
export var ViewRichTextParagraph = function ViewRichTextParagraph(_ref) {
  var value = _ref.value,
    displayMode = _ref.displayMode;
  if (displayMode === DisplayMode.Edit || displayMode === DisplayMode.Preview || displayMode === DisplayMode.Translate) {
    return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(ReactRenderer, {
      document: value
    }));
  }
  return /*#__PURE__*/React.createElement(ViewWrapper, null, /*#__PURE__*/React.createElement(ReactRenderer, {
    document: value
  }));
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var Wrapper = styled.div({
  borderStyle: 'solid',
  borderColor: "var(--ds-border-disabled, ".concat(N40, ")"),
  borderRadius: '3px',
  borderWidth: '2px',
  backgroundColor: "var(--ds-background-accent-gray-subtlest, ".concat(N20, ")"),
  padding: "var(--ds-space-075, 6px)",
  minHeight: '100px',
  color: "var(--ds-text-disabled, ".concat(N70, ")")
});